<ng-container *transloco="let t; read: 'ac'">
  <div *ngIf="loading === true" class="p-d-flex p-flex-column p-jc-center p-ai-center loading" style="height: 100vh;">
    <p-progressSpinner [style]="{width: '80px', height: '80px; margin-bottom: 40px'}" strokeWidth="1"></p-progressSpinner>
    Loading...
  </div>

  <div *ngIf="loading !== true && error !== true">
    <app-headline></app-headline>
    <div class="app" role="main">
      <router-outlet></router-outlet>
    </div>
    <app-exercise-settings-dialog></app-exercise-settings-dialog>
    <app-splash-screen></app-splash-screen>
  </div>

  <div *ngIf="loading !== true && error === true">

    <div class="p-d-flex p-flex-column p-jc-center p-ai-center" style="height: 100vh;">
      <p class="ondark p-text-center"><fa-icon class="p-pb-4 icon" [icon]="faEngineWarning"></fa-icon></p>
      <h1 class="p-text-center">
        {{ t('error') }}
      </h1>
      <p class="ondark p-text-center" [innerHtml]="t('error_message')"></p>
      <p class="ondark p-text-center"><a (click)="logoutAndGotoLogin()">{{ t('to_login') }}</a></p>
    </div>

  </div>
</ng-container>
